import { ComplexTable } from '@synergy/table';
import { Col, notification, Row } from 'antd';
import clsx from 'clsx';
import i18next from "i18next";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../../../contexts/AuthContext';
import query from '../../../../../server/constants.api';
import useFetch from "../../../../../server/useFetch";
import { PageContent, PageSection, PageTitle } from "../../../../../styles/global/Pages.styled";
import Spinner from '../../../Atomics/Spinner';
import { Text } from '../../../Atomics/Text';
import permissionToEdit from '../AccessUtils';
import { buildObj, getCustomizedButtonsForConfiguration } from '../ConfigurationUtils';
import { EditPopupConfigurations } from '../EditPopupConfigurations';

export const SelectMetricLabelsConfiguration = ({ ...props }) => {
    // Obtém a função de tradução do hook useTranslation para uso na tradução de textos
    const allowedToWrite = permissionToEdit(['Configurations', 'Metrics', 'SelectMetricLabelsConfiguration'])
    const { t } = useTranslation();
    const { tenant } = useAuthContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const [isTofecth, setIsToFetch] = useState(false);
    const [bodyToPost, setBodyToPost] = useState(null);

    const {
        data: metrics,
        refetch: refetchMetrics,
    } = useFetch("/configurations/metric-labels", "selectMetric", { tenant: tenant }, null, null, query.middlewareURL);

    const {
        data: addOrEditMetrics,
        isFetching: addOrEditMetricsIsFetching,
        error: addOrEditMetricsError,
        isSuccess: addOrEditMetricsIsSuccess,
        isError: addOrEditMetricsIsError
    } = useFetch("/configurations/metric-labels", "saveOrEditMetricConfig", bodyToPost, isTofecth, 'POST', query.middlewareURL);

    useEffect(() => {
        if (addOrEditMetricsIsError) {
            const errorMessage = addOrEditMetricsError?.response?.data?.detailedMessage || t('An error occurred while saving the metric.');

            // Usar uma notificação para exibir o erro
            notification.error({
                message: t('Error'),
                description: t(errorMessage),
                duration: 3,  // Define a duração da notificação (3 segundos)
            });
        } else if (addOrEditMetrics && !addOrEditMetricsIsFetching && addOrEditMetricsIsSuccess) {
            refetchMetrics();
            setSelectedRecord(null);
        }
        setIsToFetch(false);
    }, [addOrEditMetricsIsFetching, addOrEditMetricsIsError]);


    const modalConfiguration = [
        {
            title: t('Metric Label'),
            dataIndex: 'Metric Label',
            description: t("The field box represents the top N from the Type category."),
            required: true,
            size: 24,
        },

    ];

    function handleOkModal(data) {
        if (data && selectedRecord) {
            const bodyToPost = {
                tenant: tenant,
                selected_metric: data['Metric Label']
            };
            setBodyToPost(bodyToPost);
            setIsToFetch(true);
            setIsModalOpen(false);
            setSelectedRecord(null);
            refetchMetrics();
        }
    }

    function handleCloseModal() {
        setIsModalOpen(false);  // Fecha a modal
        setSelectedRecord(null); // Limpa o registro selecionado
    }

    return (
        <PageContent className={clsx('building_room_details', props?.className)}>
            <PageSection>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Row gutter={[16, 16]}>
                            <Col span={4}>
                                <PageTitle>
                                    <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='medium' $marginRight='s03'>{t('Metric List')}</Text>
                                </PageTitle>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        {
                            metrics ?
                                <ComplexTable fetchData={serealizeData(metrics)} language={i18next.resolvedLanguage}
                                    tableConfiguration={{ collumnsConfiguration: modalConfiguration }}
                                    pagination={{ pageSize: 5 }}
                                    customizedButtons={
                                        getCustomizedButtonsForConfiguration(metrics && allowedToWrite,
                                            () => { setSelectedRecord(emptyRecord); setIsModalOpen(true) }, t)
                                    }
                                />
                                :
                                <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <Spinner stroke="green" />
                                </div>
                        }
                    </Col>
                    <EditPopupConfigurations
                        openModal={isModalOpen}
                        closeModal={handleCloseModal}
                        onOkModal={(data) => handleOkModal(data)}
                        selectedRecord={selectedRecord ? serealizeRecordForModal(modalConfiguration, selectedRecord) : null}
                        customWidth={800} />
                </Row>
            </PageSection>
        </PageContent>
    )
}

//Serializer para tornar a modal no formato correto para editar um User, como uma configuração para a Modal
const serealizeRecordForModal = (modalConfiguration, selectedRecord, configValues) => {
    const keysToKeep = modalConfiguration.flatMap(x => {
        if (x.subfields) {
            return [...x.subfields.map(y => y.dataIndex), x.dataIndex];
        } else {
            return x.dataIndex
        }
    });

    const result = modalConfiguration.flatMap(x => {
        var obj = Object.entries(selectedRecord);
        if (x.subfields) {
            var foundObj = obj.find(z => z[0] === x.dataIndex);
            var parentObj = buildObj(foundObj, x, null, true, () => { }, configValues);
            return [({
                childs: x.subfields.map(y => {
                    var foundObj = obj.find(z => z[0] === y.dataIndex);
                    return buildObj(foundObj, y, true, parentObj.key, () => { }, configValues);
                }), parent: parentObj
            })];
        } else {
            var foundObj = obj.find(z => z[0] === x.dataIndex);
            return buildObj(foundObj, x, null, null, () => { }, configValues);
        }
    })

    return result.filter(x => {
        if (x) {
            if (x?.parent) {
                for (var i = 0; i < x.childs.length; i++) {
                    if (!x.childs[i] || !keysToKeep.includes(x.childs[i].key))
                        delete x.childs[i]
                }
                return keysToKeep.includes(x.parent.key)
            }
            return keysToKeep.includes(x.key)
        }
    });
};

const emptyRecord = {
    'Metric Label': null,
}

const serealizeData = (values) => {
    return values?.map((e, index) => {
        return {
            'id': index,//TODO JORGE: Trocar para o ID (necessário começar a criar um ID único para cada registro)
            'Metric Label': e,
        }
    })
}